import React from 'react';
import { useSelector } from 'react-redux';

import { Helmet } from 'react-helmet';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import ImportForm from 'src/component/UI/ImportForm';
import UploadStatusTable from 'src/component/UI/UploadStatusTable';

import { importDevices } from 'src/module/device/action';
import { getUploads } from 'src/module/import/selector';
import { isWhitelabel } from 'src/utils/utils';
import { useTranslation } from 'src/i18n';

export default function DeviceImportScreen () {
  const { t } = useTranslation();
  const title = isWhitelabel() ? 'ATCOM' : 'SmartTrace';
  const uploads = useSelector(getUploads);
  const uploadData: Array<any> = [];
  uploads.keySeq().forEach((key) => {
    uploadData.push({ name: uploads.getIn([key, 'file', 'name']), status: uploads.getIn([key, 'status']) });
  });

  return (
    <div id='import' className='page'>
      <Helmet>
        <title>{title} - {t('deviceImport.title')}</title>
      </Helmet>

      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Paper>
            <Grid item xs={12} md={12}>
              <h2>{t('deviceImport.title')}</h2>
              <ImportForm importType='deviceImport' importAction={importDevices} />
              <UploadStatusTable uploadData={uploadData} />
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}
